















import { Component, Vue, Inject } from "vue-property-decorator";
import Gallery, {
  SlideData,
  Options,
} from "blueimp-gallery/js/blueimp-gallery.min.js";

@Component({
  components: {},
})
export default class FullscreenGallery extends Vue {
  @Inject("window")
  private fWindow!: Window;

  private fIsLoading = true;
  private fGallery?: Gallery;

  get displayControls(): boolean {
    return !this.fWindow.matchMedia("(pointer: coarse)").matches;
  }

  get videoCoverClass(): string {
    const defaultClass = "video-cover";

    if (this.displayControls) {
      return defaultClass;
    }

    return `${defaultClass} toggle`;
  }

  public launchGalleria(
    slides: SlideData[],
    index: number,
    options: Options = {}
  ): void {
    const galleryOptions = {
      ...{
        container: this.$el,
        toggleSlideshowOnSpace: false,
        index: index,
        videoCoverClass: this.videoCoverClass,
        onslide: (index: number) => {
          this.$emit("currentIndexChange", index);
        },
        onclose: () => {
          this.$emit("galleryClosed");
        },
      },
      ...options,
    };

    this.fGallery = new Gallery(slides, galleryOptions);
  }

  public close() {
    if (!this.fGallery) {
      return;
    }

    this.fGallery.close();
  }
}
